var StateSideMenuItem;

(function (StateSideMenuItem) {
  StateSideMenuItem["ENABLED"] = "enabled";
  StateSideMenuItem["DISABLED"] = "disabled";
  StateSideMenuItem["SELECTED"] = "selected";
})(StateSideMenuItem || (StateSideMenuItem = {}));

export { StateSideMenuItem as S };
